// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import DOC_URLS from '../../../../util/doc_urls';
import {
  BannerBoldText,
  BannerButton,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../../Banner';
import * as S from './ArtifactVersionTTLBanner.styles';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {Artifact} from './CreateRegisteredCollectionDrawerInner';

type ArtifactVersionTTLBannerProps = {
  artifact: Artifact;
};

export const ArtifactVersionTTLBanner = ({
  artifact,
}: ArtifactVersionTTLBannerProps) => {
  return artifact.ttlDurationSeconds && artifact.ttlDurationSeconds > 0 ? (
    <S.BannerWithMargin variant="info">
      <BannerFlexWrapper>
        <Icon name="lightbulb-info" style={{flexShrink: 0}} />
        <BannerTextWrapper>
          <BannerBoldText>
            {<b>TTL will be deactivated. </b>}
            When linking this model artifact to the registry, any previously set
            Time to Live (TTL) or expiration on this model artifact will be
            deactivated.
          </BannerBoldText>
        </BannerTextWrapper>
      </BannerFlexWrapper>
      <BannerButton
        variant="info"
        text="Learn more"
        link={DOC_URLS.artifactTTL}
        eventData={{
          buttonInfo: 'Artifact TTL Model Registry Banner Button Clicked',
          entityName: artifact.entityName,
          projectName: artifact.projectName,
          artifactID: artifact.id,
          artifactTTLDuration: artifact.ttlDurationSeconds,
        }}
      />
    </S.BannerWithMargin>
  ) : (
    <></>
  );
};
